import {apiRequest} from '../helpers/utils';

export const notificationServices = {read, markRead};

function read({unreadOnly = false, limit = 50, cursor} = {}) {
    return apiRequest('get', 'v1/notifications', {}, {unreadOnly, limit, ...(cursor ? {cursor} : {})});
}

function markRead(ids) {
    return apiRequest('patch', 'v1/notifications/read', {ids});
}
